import { useState } from "react";
import { FaMobileAlt, FaTabletAlt, FaDesktop } from "react-icons/fa";
import { deviceSizes } from "./deviceSizes";

const Project = ({ images }) => {
  const [device, setDevice] = useState("desktop");

  return (
    <div className="d-flex flex-column align-items-center gap-4 p-4">
      {/* Toolbar สำหรับเลือกโหมดหน้าจอ */}
      <div className="btn-group position-fixed">
        <button
          className={`btn ${device === "desktop" ? "btn-dark" : "btn-secondary"}`}
          onClick={() => setDevice("desktop")}
        >
          <FaDesktop size={20} />
        </button>
        <button
          className={`btn ${device === "tablet" ? "btn-dark" : "btn-secondary"}`}
          onClick={() => setDevice("tablet")}
        >
          <FaTabletAlt size={20} />
        </button>
        <button
          className={`btn ${device === "mobile" ? "btn-dark" : "btn-secondary"}`}
          onClick={() => setDevice("mobile")}
        >
          <FaMobileAlt size={20} />
        </button>
      </div>

      {/* กล่อง Preview ที่เปลี่ยนขนาดและสีพื้นหลังตามที่เลือก */}
      <div
        className={`border-2 border-gray-400 mt-5 shadow-lg overflow-hidden ${deviceSizes[device].bgColor} rounded-3 mobile-view`}
        style={{
          width: deviceSizes[device].size,
          height: "auto",
        }}
      >
         <img
          src={`/${images[device]}`}
          alt={`${device} image`}
          className="w-full h-auto object-cover"
        />
      </div>
    </div>
  );
};

export default Project;
